import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

import Outstream from './Outstream'
import ClickaduBanner from './ClickaduBanner'

class Advertisement extends Component {
  constructor(props) {
    super(props)

    this.state = {
      cacheKey: new Date().getTime(),
      bannerSize: null
    }

    /* eslint-disable */
    this._banners = {
      default: {
        '300x250': {
          center: <ClickaduBanner size={"300x250"} position={props.position} />,
          bottom: <ClickaduBanner size={"300x250"} position={props.position} />
        },
        '728x90': {
          center: <ClickaduBanner size={"728x90"} position={props.position} />,
          bottom: <ClickaduBanner size={"728x90"} position={props.position} />
        }
      },
      reader: {
        '300x250': {
          center: <ClickaduBanner size={"300x250"} position={props.position} />,
          bottom: <ClickaduBanner size={"300x250"} position={props.position} />
        },
        '728x90': {
          center: <ClickaduBanner size={"728x90"} position={props.position} />,
          // bottom: <ExoBanner zoneId={4411790} neverblock={4411780} position={props.position} width={728} height={90} />
          bottom: <ClickaduBanner size={"728x90"} position={props.position} />
        }
      }
    }
    /* eslint-enable */

    this.onWindowResize = this.onWindowResize.bind(this)
  }

  static determineBannerSize() {
    if (window.innerWidth > 991) {
      return '728x90'
    }

    return '300x250'
  }

  reload() {
    this.setState({ cacheKey: new Date().getTime() }, () => {
      this._reloadTimer = setTimeout(() => {
        this.reload()
      }, Advertisement.RELOAD_TIMER)
    })
  }

  onWindowResize() {
    if (this.props.size !== 'banner') {
      return
    }

    if (Advertisement.determineBannerSize() !== this.state.bannerSize) {
      this.setState({
        cacheKey: new Date().getTime(),
        bannerSize: Advertisement.determineBannerSize()
      })
    }
  }

  componentDidMount() {
    this.setState({
      cacheKey: new Date().getTime(),
      bannerSize: Advertisement.determineBannerSize()
    })

    window.addEventListener('resize', this.onWindowResize)
    this._reloadTimer = setTimeout(() => {
      this.reload()
    }, Advertisement.RELOAD_TIMER)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize)
    clearInterval(this._reloadTimer)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.reload()
    }
  }

  render() {
    const { bannerSize } = this.state

    const section = this.props.section || 'default'
    const position = this.props.position || 'center'

    if (section !== 'reader' && position === 'bottom') {
      return (
        <Outstream neverblock={bannerSize === '728x90' ? 5182292 : 4411780} />
      )
    }

    /*if (
      section === 'reader' &&
      position === 'bottom' &&
      bannerSize === '728x90'
    ) {
      return <StickyBanner />
    }*/

    if (!bannerSize) {
      return ''
    }

    let banner = this._banners[section]
    if (!banner) {
      banner = this._banners['default']
    }
    const zoneData = banner[bannerSize]
    if (!zoneData) {
      return ''
    }

    const zone = zoneData[position]

    return (
      <div
        key={this.state.cacheKey}
        className="text-center mt-2 mb-2"
        data-size={bannerSize}
      >
        {zone}
      </div>
    )
  }
}

Advertisement.RELOAD_TIMER = 45000

Advertisement.propTypes = {
  size: PropTypes.string,
  section: PropTypes.string,
  position: PropTypes.string
}

export default withRouter(Advertisement)
